import React, {useState} from "react";
import Styles from './SkippedActivities/SkippedActivities.module.scss'
import {detectDir} from "../../../../../../util/util";
const SkippedActivities = ({data}) => {
    const [open , setOpen] = useState(false)
    return(
        <div onClick={() => setOpen(!open)} onBlur={() => setOpen(false)} tabIndex={-1} className={`${Styles.dropDown} ${open && Styles.active} ${data.length === 0 && 'disable'}`}>
            <p>Skipped Activities</p>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.66675 3.33329L10.3334 7.99996L5.66675 12.6666" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {(open && data.length > 0) &&
            <div className={Styles.open} >
                {data.map((item,key)=>(
                    <div dir={detectDir(item)}  key={key} className={`d-flex align-items-center ${Styles.item}`}>
                        <p>{item}</p>
                    </div>
                ))}
            </div>}
        </div>
    )
}
export default SkippedActivities;